import React from "react";
import {
  Modal,
  FormTextarea,
  Button,
  Loader,
  FormCheckbox,
  FormSelect,
  FormInput,
} from "ui-kit-ck-consultant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { Row, Col } from "react-flexbox-grid";
import { format } from "date-fns";

import axiosConfig from "../../utils/axiosConfig";

import AuthContext from "../../context/AuthContext";

export default class ModalSendSMS extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: false,
      messageSMS: "",
      messageSMSRepairer: "",
      messageSMSConfirmation: "",
      messageSMSConfirmationRepairer: "",
      messageSMSInstant: "",
      messageSMSInstantRepairer: "",
      // "invitation" = le client prend RDV
      // "confirmation" = RDV déjà pris par l'expert
      // "instant" = visio instantanée (aucun RDV, aucun créneau)
      messageMode: "invitation",
      phoneNumber: "DEFAULT",
      otherPhoneNumber: "",
      isProgramm: false,
    };
  }

  static contextType = AuthContext;

  // Un RDV est déjà pris sur le dossier -> on peut envoyer une confirmation.
  hasAppointment = () =>
    !!(this.props.dateAppointment && this.props.hourAppointment);

  // Retire l'indentation parasite des messages enregistrés avant le correctif
  // (template literal indenté dans la source).
  cleanMessage = (text) =>
    String(text || "")
      .split("\n")
      .map((line) => line.trim())
      .join("\n");

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    this.setState({
      [name]: checked,
    });
  };

  componentDidUpdate(prevProps) {
    const opened = prevProps.show !== this.props.show && this.props.show;
    const templatesChanged =
      prevProps.messageSMS !== this.props.messageSMS ||
      prevProps.messageSMSRepairer !== this.props.messageSMSRepairer ||
      prevProps.visioInstant !== this.props.visioInstant;
    if (opened || templatesChanged) {
      this.resetMessages();
    }
  }

  // Formate la date du RDV en JJ/MM/AAAA (tolère Date, ISO ou chaîne).
  formatAppointmentDate = () => {
    const value = this.props.dateAppointment;
    if (!value) return "";
    const date = new Date(value);
    return isNaN(date.getTime()) ? String(value) : format(date, "dd/MM/yyyy");
  };

  // Heure du RDV en HH:MM (retire les secondes éventuelles).
  formatAppointmentHour = () =>
    String(this.props.hourAppointment || "").slice(0, 5);

  // Message de confirmation : le RDV est déjà réservé, [URL] est remplacé côté serveur.
  buildConfirmationMessages = () => {
    const date = this.formatAppointmentDate();
    const hour = this.formatAppointmentHour();
    const vehicle = `${this.props.brand || ""} ${this.props.model || ""} ${
      this.props.licensePlate || ""
    }`.trim();
    const signature = `Cordialement, ${this.context.name || ""} ${
      this.context.groupName ? this.context.groupName : ""
    }`.trim();

    const messageSMSConfirmation = `Bonjour ${this.props.kind || ""} ${
      this.props.insuredName || ""
    }, votre expertise vidéo${
      vehicle ? ` de votre véhicule ${vehicle}` : ""
    } en visioconférence est confirmée le ${date} à ${hour}. Le jour du rendez-vous, cliquez sur ce lien pour rejoindre la visio : [URL] . ${signature}`;

    const messageSMSConfirmationRepairer = `Bonjour ${
      this.props.repairerName || ""
    }, l'expertise vidéo${
      vehicle ? ` du véhicule ${vehicle}` : ""
    } en visioconférence est confirmée le ${date} à ${hour}. Le jour du rendez-vous, cliquez sur ce lien pour rejoindre la visio : [URL] . ${signature}`;

    return { messageSMSConfirmation, messageSMSConfirmationRepairer };
  };

  // Message de visio instantanée : aucun RDV, le client rejoint tout de suite.
  buildInstantMessages = () => {
    const vehicle = `${this.props.brand || ""} ${this.props.model || ""} ${
      this.props.licensePlate || ""
    }`.trim();
    const signature = `Cordialement, ${this.context.name || ""} ${
      this.context.groupName ? this.context.groupName : ""
    }`.trim();

    const messageSMSInstant = `Bonjour ${this.props.kind || ""} ${
      this.props.insuredName || ""
    }, nous réalisons l'expertise vidéo${
      vehicle ? ` de votre véhicule ${vehicle}` : ""
    } en visioconférence maintenant. Cliquez sur ce lien pour rejoindre la visio immédiatement : [URL] . ${signature}`;

    const messageSMSInstantRepairer = `Bonjour ${
      this.props.repairerName || ""
    }, nous réalisons l'expertise vidéo${
      vehicle ? ` du véhicule ${vehicle}` : ""
    } en visioconférence maintenant. Cliquez sur ce lien pour rejoindre la visio immédiatement : [URL] . ${signature}`;

    return { messageSMSInstant, messageSMSInstantRepairer };
  };

  resetMessages = () => {
    const { messageSMSConfirmation, messageSMSConfirmationRepairer } =
      this.buildConfirmationMessages();
    const { messageSMSInstant, messageSMSInstantRepairer } =
      this.buildInstantMessages();

    // Priorité : visio instantanée > RDV déjà pris > invitation
    let messageMode = "invitation";
    if (this.props.visioInstant) {
      messageMode = "instant";
    } else if (this.hasAppointment()) {
      messageMode = "confirmation";
    }

    this.setState({
      messageSMS: this.cleanMessage(this.props.messageSMS),
      messageSMSRepairer: this.cleanMessage(this.props.messageSMSRepairer),
      messageSMSConfirmation,
      messageSMSConfirmationRepairer,
      messageSMSInstant,
      messageSMSInstantRepairer,
      messageMode,
    });
  };

  // Nom du champ (et donc du message) actif selon destinataire + mode.
  getActiveMessageField = () => {
    const isRepairer = this.props.repairerPhone === this.state.phoneNumber;
    if (this.state.messageMode === "instant") {
      return isRepairer ? "messageSMSInstantRepairer" : "messageSMSInstant";
    }
    if (this.state.messageMode === "confirmation") {
      return isRepairer
        ? "messageSMSConfirmationRepairer"
        : "messageSMSConfirmation";
    }
    return isRepairer ? "messageSMSRepairer" : "messageSMS";
  };

  // start sendSMS

  sendSMS = () => {
    const activeField = this.getActiveMessageField();
    this.setState({ isLoad: true }, () => {
      axiosConfig("folder/send-sms", {
        data: {
          id: this.props.id,
          token: this.props.token,
          phoneNumber:
            this.state.phoneNumber === "Autre"
              ? this.state.otherPhoneNumber
              : this.state.phoneNumber,
          messageSMS: this.state[activeField],
          dateAppointment: this.props.dateAppointment,
          hourAppointment: this.props.hourAppointment,
          isProgramm: this.state.isProgramm,
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.setState(
              {
                isLoad: false,
              },
              () => {
                this.props.getFolder(false);
                alert("SMS envoyé");
                this.props.onClose();
              }
            );
          } else {
            this.sendSMSError();
          }
        })
        .catch(this.sendSMSError);
    });
  };

  sendSMSError = () => {
    this.setState({ isLoad: false }, () => alert("Une erreur est survenue."));
  };

  // end sendSMS

  render() {
    const activeField = this.getActiveMessageField();
    const activeMessage = this.state[activeField];
    return (
      <>
        <Modal
          show={this.props.show}
          onClose={this.props.onClose}
          title={`SMS prise RDV`}
        >
          <FormSelect
            className="mb-20"
            title="Destinataire"
            value={this.state.phoneNumber}
            name="phoneNumber"
            ignore={true}
            options={[
              { text: "Choix du destinataire", value: "DEFAULT" },
              {
                text: `Assuré : ${this.props.insuredPhone}`,
                value: this.props.insuredPhone,
              },
              {
                text: `Réparateur : ${this.props.repairerPhone}`,
                value: this.props.repairerPhone,
              },
              {
                text: `Autre`,
                value: "Autre",
              },
            ]}
            onChange={this.handleInputChange}
          />
          {this.state.phoneNumber === "Autre" && (
            <FormInput
              className="mb-20"
              title="Numéro personnalisé"
              value={this.state.otherPhoneNumber}
              name="otherPhoneNumber"
              onChange={this.handleInputChange}
            />
          )}
          {this.props.visioInstant ? (
            <p
              className="mb-20"
              style={{ fontSize: 13, color: "#1d6f42", margin: 0 }}
            >
              Visio instantanée : le client entrera directement en
              visioconférence via ce lien (aucun RDV, aucun créneau consommé).
            </p>
          ) : (
            this.hasAppointment() && (
              <FormCheckbox
                className="mb-20"
                text={`RDV déjà pris — envoyer une confirmation (${this.formatAppointmentDate()} à ${this.formatAppointmentHour()})`}
                name="isConfirmation"
                checked={this.state.messageMode === "confirmation"}
                onChange={(e) =>
                  this.setState({
                    messageMode: e.target.checked
                      ? "confirmation"
                      : "invitation",
                  })
                }
              />
            )
          )}
          <FormTextarea
            className="mb-20"
            name={activeField}
            value={activeMessage}
            onChange={this.handleInputChange}
            rows={10}
          />
          <Row>
            <Col xs={12}>
              <FormCheckbox
                className="mb-20"
                text="Envoi différé"
                name="isProgramm"
                checked={this.state.isProgramm}
                onChange={this.handleCheckboxChange}
              />
            </Col>
            <Col xs={12} md={6}>
              <Button
                outline
                className="mb-20"
                text="Annuler"
                onClick={() => this.props.onClose()}
              >
                <FontAwesomeIcon icon={faTimes} />
              </Button>
            </Col>
            <Col xs={12} md={6}>
              <Button
                className="mb-20"
                text="Confirmer l'envoi"
                disabled={
                  !activeMessage ||
                  this.state.phoneNumber === "DEFAULT" ||
                  (this.state.phoneNumber === "Autre" &&
                    !this.state.otherPhoneNumber)
                }
                onClick={() => this.sendSMS()}
              >
                <FontAwesomeIcon icon={faPaperPlane} />
              </Button>
            </Col>
          </Row>
        </Modal>
        <Loader />
      </>
    );
  }
}
